import type {GetChangeApiArg} from '../../../../../services/rest'
import type {ChangeId} from '../../../../../types'
import {stringifyId} from '../../../../../types'

export const getPersonalChangeArg = (changeId: ChangeId): GetChangeApiArg => ({
  changeLocator: `id:${stringifyId(changeId)},personal:true`,
  fields: 'id,comment',
})
